import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";

export const StructuredData = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <div className="flex flex-wrap items-center">
      <div className="my-1 flex items-center overflow-hidden pr-3">
        <FontAwesomeIcon
          className="mr-2 shrink-0 text-gray-600"
          icon={faFileAlt as IconProp}
        />
        <div className="overflow-hidden text-ellipsis">{title}</div>
      </div>
      <div className="my-1 flex items-center">{children}</div>
    </div>
  );
};
